import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '@/CheckoutPage.css';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_only-creator/artifacts/90vlzise_original%20color%20logo%20%281%29.png';
const GHL_CHECKOUT_URL = 'https://audit.2dollarbillbrand.com/checkout-page';

const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

export default function CheckoutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    trackEvent('checkout_page_viewed', { page_title: 'checkout' });
  }, []);

  return (
    <div className="checkout-page" data-testid="checkout-page">
      <div className="checkout-container">

        {/* Section 1 - Header */}
        <div className="checkout-logo-wrap" data-testid="checkout-logo">
          <Link to="/audit">
            <img src={LOGO_URL} alt="$2 Bill Brand Logo" className="checkout-logo" />
          </Link>
        </div>

        <section className="checkout-header" data-testid="checkout-header">
          <h1 className="checkout-headline">Complete Your ONLY Statement Audit</h1>
          <p className="checkout-sub">You are one step away from turning your ONLY statement into real authority.</p>
        </section>

        {/* Section 2 - Order Summary */}
        <section className="checkout-card checkout-summary" data-testid="checkout-summary">
          <h2 className="checkout-card-title">ONLY Statement Audit</h2>
          <ul className="checkout-features" data-testid="checkout-features">
            <li>60-minute private strategy session with Brad Holcman</li>
            <li>Deep positioning and brand clarity session</li>
            <li>15-17 page positioning PDF delivered within 48 hours</li>
            <li>Your refined ONLY statement and strategic positioning</li>
            <li>$797 credit toward the Authority Accelerator</li>
          </ul>
          <div className="checkout-price-row" data-testid="checkout-price">
            <span className="checkout-price" data-testid="checkout-price-discounted">$797</span>
          </div>
          <p className="checkout-bump-note">Optional: Add a 30-Minute Follow-Up Strategy Session for $197 during checkout.</p>
        </section>

        {/* Section 3 - Checkout Button */}
        <section className="checkout-cta-section" data-testid="checkout-cta-section">
          <a
            href={GHL_CHECKOUT_URL}
            className="checkout-cta-btn"
            data-testid="checkout-cta-btn"
            onClick={() => trackEvent('checkout_cta_clicked', { destination: 'ghl_checkout' })}
          >
            Book My ONLY Statement Audit
          </a>
        </section>

        {/* Section 4 - Trust Indicators */}
        <section className="checkout-trust" data-testid="checkout-trust">
          <div className="checkout-trust-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            <span>Secure Stripe Payment</span>
          </div>
          <div className="checkout-trust-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            <span>60-Minute Private Session</span>
          </div>
          <div className="checkout-trust-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
            <span>15-17 Page Positioning PDF</span>
          </div>
        </section>

        {/* Section 5 - Guarantee */}
        <section className="checkout-card checkout-guarantee" data-testid="checkout-guarantee">
          <h3 className="checkout-guarantee-headline">A Strategic Conversation That Changes How You Position Yourself</h3>
          <p className="checkout-guarantee-body">This is not a generic strategy call. This is a focused working session with Brad Holcman designed to uncover the positioning that makes you impossible to compete with.</p>
        </section>

      </div>
    </div>
  );
}
